<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	
	export default {
		   globalData: {  
		   // baseUrl: 'http://133.46.152.141',
			 baseUrl: 'https://m.ysymt.cn/',
		  },
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style>
	page {
		height: 100%;
	}
	 ::-webkit-scrollbar {
	    width: 3px;
	  }
	::-webkit-scrollbar-track {
	    background-color: rgba(255, 0, 0, 0);
	  }
::-webkit-scrollbar-thumb {
	    width: 3px;
	    background: #DDDDDD;
	    border-radius: 2px;
	  }
	  .uni-input-input {
	      color: black;
	  }
</style>